/**
 * @generated SignedSource<<f694577326160ed6903c3706ddfca645>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CreateHubspotIntegrationInput = {
  step?: string | null;
  returnUrl?: string | null;
  code?: string | null;
  state?: string | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type CreateHubspotIntegrationMutation$variables = {
  input: CreateHubspotIntegrationInput;
};
export type CreateHubspotIntegrationMutation$data = {
  readonly createHubspotIntegration: {
    readonly redirectUrl: string | null;
    readonly errors: ReadonlyArray<string | null> | null;
  } | null;
};
export type CreateHubspotIntegrationMutation = {
  variables: CreateHubspotIntegrationMutation$variables;
  response: CreateHubspotIntegrationMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateHubspotIntegrationPayload",
    "kind": "LinkedField",
    "name": "createHubspotIntegration",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "redirectUrl",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "errors",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CreateHubspotIntegrationMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CreateHubspotIntegrationMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "1cdc3d8fc57f85aa8cf557ce2e836222",
    "id": null,
    "metadata": {},
    "name": "CreateHubspotIntegrationMutation",
    "operationKind": "mutation",
    "text": "mutation CreateHubspotIntegrationMutation(\n  $input: CreateHubspotIntegrationInput!\n) {\n  createHubspotIntegration(input: $input) {\n    redirectUrl\n    errors\n  }\n}\n"
  }
};
})();

(node as any).hash = "dfd93ba56c46aec8148219e2075ddcf2";

export default node;
